import { useState } from 'react';
import { createPortal } from 'react-dom';

import { useContextualSurface } from 'approot/shared/ally/contextual.hooks';
import IconBorderWidths from 'approot/shared/inline-svg/activity-builder/icon-border-widths';
import {
  PencilProps,
  EraserProps,
  ToolScale,
  SUB_MENU_PORTAL_ID,
} from '../draw-canvas.constants';
import ToolSize from './tool-size';
import { ToolBarTool } from './toolbar.style';
import ToolbarItem from './toolbar-item';

type Props = {
  tool: PencilProps | EraserProps | null;
  scale: ToolScale;
  hoverText: string;
  setSize: (size: number) => void;
};

const ToolbarItemSize = ({ tool, scale, hoverText, setSize }: Props) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const { styles, attributes, setReferenceElement, setPopperElement } =
    useContextualSurface(isActive, setIsActive, {
      offset: [70, -100],
      placement: 'left-start',
      strategy: 'fixed',
    });

  const portalContainer = document.getElementById(SUB_MENU_PORTAL_ID);

  const renderSizePanel = () => {
    if (!tool) return null;
    return (
      <div
        ref={setPopperElement}
        role="dialog"
        className="upper-canvas"
        tabIndex={-1}
        style={styles.popper}
        {...attributes.popper}
      >
        <ToolSize size={tool.size} scale={scale} setSize={setSize} />
      </div>
    );
  };

  return (
    <>
      <ToolbarItem hoverText={hoverText}>
        <ToolBarTool
          ref={setReferenceElement}
          $isActive={isActive}
          aria-label="Change size of selected control"
          onClick={() => {
            setIsActive(!isActive);
          }}
        >
          <IconBorderWidths width={20} height={20} />
        </ToolBarTool>
      </ToolbarItem>
      {isActive &&
        tool &&
        (portalContainer
          ? createPortal(renderSizePanel(), portalContainer)
          : renderSizePanel())}
    </>
  );
};

export default ToolbarItemSize;
